import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/regulatory-affairs/regulatory-affairs-for-pharma-and-biotech/combination-products")({
  head: () => buildRouteHead("/en/services/regulatory-affairs/regulatory-affairs-for-pharma-and-biotech/combination-products", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/industries/combination-products", replace: true });
  },
});
